export default __webpack_public_path__ + "050b26c9e4cb1daad08c43c832be4e15.webp";